module.exports = __webpack_public_path__ + "static/media/1.423d0ca6.png";